import { MeasurementTagRequest } from "@/components/Measurements/Types/MeasurementPoint";

export type StepTypes = "Check" | "SatosLive" | "Text" | "ManualMeasurement";

export enum CheckpointType {
	Checkpoint = "Checkpoint",
	Info = "Info",
	SATOSLive = "SATOSLive",
	ManualMeasurement = "ManualMeasurement",
}

export enum UpdatesColumn {
	Value = "Value",
	AccessLevel = "ansvarlig",
	ConnectedTo = "koble",
	Index = "tabelnr",
	NumberOfFields = "feltstorelse",
	GroupId = "GroupId",
	IsSkipped = "IsSkipped",
	IsOverridden = "IsOverridden",
	BackgroundColor = "BackgroundColor",
	CheckpointType = "CheckpointType",
}

export interface SATOSLiveTag {
	Id: number;
	Name: string;
	Description: string;
	TagId: string;
	limit0: number;
	limit1: number;
	brukerid?: number;
}

export interface CreateChecklistRequest {
	ProcedureId: number;
	NodeId: number;
	ChecklistType: ChecklistTypes;
}

export interface CreateChecklistResponse {
	ChecklistId: number;
}

export interface AddMeasurementTagToChecklistStepRequest {
	StepId: number;
	ChecklistId: number;
	MeasurementTag: MeasurementTagRequest;
}
export interface CreateChecklistStepRequest {
	ProcedureId: number;
	ChecklistId: number;
	StepId: number;
	CheckpointType: CheckpointType;
}

export interface UpdateChecklistStepRequest {
	StepId: number;
	ChecklistId: number;
	Updates: Partial<Record<UpdatesColumn, any>>;
}

export interface DeleteChecklistStepRequest {
	StepId: number;
	ChecklistId: number;
}

export interface DeleteMeasurementTagFromChecklistStepRequest {
	StepId: number;
	ChecklistId: number;
	MeasurementTagId: number;
}

export enum ChecklistTypes {
	ManualChecklist = 0,
	ImportedChecklist = 1,
	MaterialHandlingChecklist = 2,
}
